export const ADMIN_PLATFORM_POS_LIST_TRANSLATION_NAMESPACE = "platform-pos-list";

export const ADMIN_PLATFORM_POS_LIST_TK = "ADMIN_PLATFORM_POS_LIST_TK";
